import DotNetObject = DotNet.DotNetObject;

export const JobBlobConfigurationService = (() => {
  let dotNetObj: DotNetObject;
  let cachedSchedulerTemplateConfiguration: string;
  let cachedTooltipTemplateConfiguration: string;

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const getSchedulerTemplateConfiguration = async (useCache: boolean = true): Promise<string> => {
    if (useCache && cachedSchedulerTemplateConfiguration != null)
      return cachedSchedulerTemplateConfiguration;

    if (dotNetObj) {
      cachedSchedulerTemplateConfiguration = await dotNetObj.invokeMethodAsync<string>('GetSchedulerTemplateConfigurationAsync');
      return cachedSchedulerTemplateConfiguration;
    } else {
      throw 'Job Blob Configuration DotNet Object Reference has not yet been implemented';
    }
  };

  const getTooltipTemplateConfiguration = async (useCache: boolean = true): Promise<string> => {
    if (useCache && cachedTooltipTemplateConfiguration != null)
      return cachedTooltipTemplateConfiguration;

    if (dotNetObj) {
      cachedTooltipTemplateConfiguration = await dotNetObj.invokeMethodAsync<string>('GetTooltipTemplateConfigurationAsync');
      return cachedTooltipTemplateConfiguration;
    } else {
      throw 'Job Blob Configuration DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    getSchedulerTemplateConfiguration,
    getTooltipTemplateConfiguration,
  };
})();
